import { createContext, useContext, useEffect, useState } from "react";
import { usePlant } from "../services/hooks";
import { useUserDetail } from "../services/hooks";
import { Loader } from "../Components/utils";
import PublicRoute from "../routes/PublicRoute";
import { useGetPlantMutation } from "../api/vmsSlice";
// import { useNavigate } from "react-router-dom";

const PlantContext = createContext();
export function PlantProvider({ children }) {
	const [plantId, setPlantId] = useState(null);
	const [plantOptions, setPlantOptions] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const { userDetail, isFetching: isUserDetailLoading } = useUserDetail();
	const [getPlantDetails, { data: plantData, isLoading: isPlantLoading, reset }] = useGetPlantMutation({});
	//   const navigate = useNavigate();

	useEffect(() => {
		if (userDetail) {
			//   setOrgId(userDetail?.orgId);
			if (userDetail.userType !== "superAdmin") {
				getPlantDetails({ orgId: userDetail?.orgId });
			} else {
				setIsLoading(false);
			}
		}
	}, [userDetail]);

	useEffect(() => {
		if (!plantData) return;

		if (plantData.data?.length > 0) {
			const plantOptions = plantData?.data.map((_) => ({ label: _.plantName, value: _._id, plantCode: _?.plantCode || "" }));
			setPlantOptions(plantOptions);
			const localStoragePlantId = localStorage.getItem("plantId");
			if (plantOptions.some((option) => option.value === localStoragePlantId)) {
				setPlantId(localStoragePlantId);
				// console.log("PLANT ID", plantId)
			} else {
				setPlantId(plantOptions[0]?.value);
			}
			setIsLoading(false);
		} else {
			setIsLoading(false);
			//   window.location.replace("/not-authorized")
			//   navigate("/not-authorized")
		}
	}, [plantData]);

	const updatePlantId = (selectedOption) => {
		const newPlantId = selectedOption?.value || plantOptions?.[0]?.value;
		setPlantId(newPlantId);
		localStorage.setItem("plantId", newPlantId);
	};

	const [isCheckpointForm, setIsCheckpointForm] = useState(false);
	
	const contextValue = {
		plantId,
		plantName: plantOptions?.find(_=> _.value == plantId)?.label || "",
		plantCode: plantOptions?.find(_=> _.value == plantId)?.plantCode || "",
		plantOptions: plantOptions || [],
		loading: isLoading,
		updatePlantId,
		getPlantDetails,
		isCheckpointForm,
		setIsCheckpointForm,
	};
	return <PlantContext.Provider value={contextValue}>{!localStorage.getItem("secretkey") ? children : isLoading ? <Loader height="100vh" /> : children}</PlantContext.Provider>;
}
export function usePlantContext() {
	const context = useContext(PlantContext);
	if (!context) {
		throw new Error("usePlantContext must be used within a PlantProvider");
	}
	return context;
}
